import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/psiapp_plus_logo.png'


const _hoisted_1 = { class: "card bg-info-soft" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  height: "30",
  class: "mb-3"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Quer mais visibilidade para seus pacientes e benefícios pra você? ", -1)

import {
  EOffcanvasViews,
  navigateCanvas,
} from "../OffcanvasViews/OffcanvasViewsConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'PsiappPlusCard',
  setup(__props) {

const handlePsiappPlus = () => {
  navigateCanvas(EOffcanvasViews.subscription);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "card-body" }, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("button", {
        class: "btn btn-info",
        onClick: handlePsiappPlus
      }, " Assinar Psiapp+ ")
    ])
  ]))
}
}

})